export const others = {
  personal: {
    affluentProposition: {
      about: {
        description: 
          `<p>alrajhi bank Malaysia's Affluent Banking offers you exclusive services tailored specially to your needs. We strive to offer the highest standards in complete banking service, which includes assigning you a dedicated Relationship Manager who will support and guide you through your financial decisions.</p>`,
        title: "About",
      },
      benefits: {
        description: [
          `<div><span>Embark on the Road to Haramain</span><div>
          <ul className="text-black-50">
            <li>Our Personal Financing-i Umrah enables you to perform pilgrimage with peace of mind knowing your finances are well taken care of.</li>
          </ul>
          `,
          `<div><span>Achieve Financial Liberty for a Better Future</span><div>
          <ul className="text-black-50">
            <li>Get a full range of Islamic financial solutions, from wealth acceleration to Islamic estate planning</li>
            <li>Receive invites to financial reviews, wealth webinars, and exclusive customer events.</li>
          </ul>
          `,
          `<div><span>Open new opportunities, with our support</span><div>
          <ul className="text-black-50">
            <li>Get preferential rates with our various financing solutions, whether it is to fund your children's education or to buy your dream house.</li>
          </ul>
          `,
          `<div><span>Other services</span><div>
          <ul className="text-black-50">
            <li>Dedicated Relationship Manager</li>
            <li>Priority queue privilege at alrajhi bank Malaysia branches</li>
            <li>Priority applications for financing facilities</li>
          </ul>
          `,
        ],
        title: "Benefits",
      },
      howto: {
        description: [
          `<ul>
            <li className="mb-3">Maintain a Total Relationship Balance (TRB*) of at least RM150,000 or more at any given time, or</li>
            <li className="my-3">Total home financing-i of a minimum of RM1,000,000 or more, or</li>
            <li className="my-3">Credit a net monthly salary of RM17,500 into your alrajhi bank Malaysia account on a monthly basis</li>
          <ul>`,
          `*TRB refers to total deposit in any current account-i, savings account-i, term deposit account-i and/or investment in any Unit Trust Fund with the Bank`
        ],
        title: "How to be an alrajhi <br/>bank Malaysia Affluent Customer"
      },
      shariahContract: {
        description: [
          `Wakalah`,
          `Wadi'ah`,
          `Bai'al sarf`
        ],
        title: "Shariah Contract",
      },
      minimumPurchase: {
        description: [
          `Initial and subsequent purchases:`,
          `<span>Individual</span> - Minimum of RM10 worth of Gold or its equivalent in gram`,
          `<span>Non-individual</span> - Minimum of RM100 worth of Gold or its equivalent in gram`,
        ],
        title: "Minimum Purchase"
      },
    },
  }
}